var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('footer',{staticClass:"text-muted monaco"},[_vm._v(" Copyright © 2019 - "+_vm._s(_vm.now)+". All rights reserved. ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }